import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_helpers/auth.guard';

const loginModule = () =>
  import('./login/login.component').then((x) => x.LoginComponent);
const dashboardModule = () =>
  import('./dashboard/dashboard.component').then((x) => x.DashboardComponent);
const studentModule = () =>
  import('./student/student.component').then((x) => x.StudentComponent);
const addStudentModule = () =>
  import('./student/add-student/add-student.component').then(
    (x) => x.AddStudentComponent,
  );
const trackHistoryModule = () =>
  import('./track-history/track-history.component').then(
    (x) => x.TrackHistoryComponent,
  );
const settingsModule = () =>
  import('./settings/settings.component').then((x) => x.SettingsComponent);

const adminsModule = () =>
  import('./admins-list/admins-list.component').then(
    (x) => x.AdminsListComponent,
  );

const studentListModule = () =>
  import('./student-list/student-list.component').then(
    (x) => x.StudentListComponent,
  );

const floorModule = () =>
  import('./floorslist/floorslist.component').then(
    (x) => x.FloorslistComponent,
  );

const locationModule = () =>
  import('./locations-list/locations-list.component').then(
    (x) => x.LocationsListComponent,
  );

const deviceModule = () =>
  import('./device-configuration/device-configuration.component').then(
    (x) => x.DeviceConfigurationComponent,
  );

const categoriesModule = () =>
  import('./categories-list/categories-list.component').then(
    (x) => x.CategoriesListComponent,
  );

const hostelDashboardModule = () =>
  import('./hostel-dashboard/hostel-dashboard.component').then(
    (x) => x.HostelDashboardComponent,
  );

const studentActivityModule = () =>
  import('./student-activity/student-activity.component').then(
    (x) => x.StudentActivityComponent,
  );

const routes: Routes = [
  {
    path: 'login',
    loadComponent: loginModule,
  },
  {
    path: 'dashboard',
    loadComponent: dashboardModule,
    canActivate: [AuthGuard],
  },

  {
    path: 'studentActivity',
    loadComponent: trackHistoryModule,
    canActivate: [AuthGuard],
  },

  {
    path: 'settings',
    loadComponent: settingsModule,
    canActivate: [AuthGuard],
  },
  {
    path: 'admins',
    loadComponent: adminsModule,
    canActivate: [AuthGuard],
  },
  {
    path: 'student-list',
    loadComponent: studentListModule,
    canActivate: [AuthGuard],
  },
  {
    path: 'floorslist',
    loadComponent: floorModule,
    canActivate: [AuthGuard],
  },

  {
    path: 'locationslist',
    loadComponent: locationModule,
    canActivate: [AuthGuard],
  },

  {
    path: 'device-configuration',
    loadComponent: deviceModule,
    canActivate: [AuthGuard],
  },
  {
    path: 'categories-list',
    loadComponent: categoriesModule,
    canActivate: [AuthGuard],
  },


  {
    path: 'hostelDashboard',
    loadComponent: hostelDashboardModule,
    canActivate: [AuthGuard],
  },


  {
    path: 'track-history',
    loadComponent: studentActivityModule,
    canActivate: [AuthGuard],
  },

  {
    path: 'student',
    loadComponent: studentModule,
    canActivate: [AuthGuard],
  },
  {
    path: 'add-student',
    loadComponent: addStudentModule,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
